import React, { useState, useContext } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  CircularProgress,
  Box,
  Typography
} from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import api from '../../services/api';
import toastError from '../../errors/toastError';
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
	wrapper: {
		position: "relative",
	},
	buttonProgress: {
		color: green[500],
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -12,
		marginLeft: -12,
	},
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  infoBox: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: theme.palette.text.secondary,
  }
}));

const NoteModal = ({ open, onClose, ticketId }) => {
  const classes = useStyles();
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);
  const { user } = useContext(AuthContext);

  const handleClose = () => {
    setNote('');
    onClose();
  };

  const handleSaveNote = async () => {
    if (note.trim() === '') return;
    setLoading(true);

    const finalBody = `*${user.name}:*\n${note.trim()}`;

    const message = {
      body: finalBody,
      isNote: true,
      fromMe: true,
      read: true,
    };

    try {
      await api.post(`/messages/${ticketId}`, message);
    } catch (err) {
      toastError(err);
    }

    setLoading(false);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm" scroll="paper">
      <DialogTitle>Añadir Nota Interna</DialogTitle>
      
      <DialogContent dividers className={classes.dialogContent}>
        
        <Box className={classes.infoBox}>
          <InfoOutlinedIcon fontSize="small" />
          <Typography variant="body2">
            Esta nota es interna y no será visible para el contacto.
          </Typography>
        </Box>

        <TextField
          autoFocus
          label="Escribe tu nota aquí..."
          fullWidth
          multiline
          rows={5}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          variant="outlined"
        />
      </DialogContent>
      
      <DialogActions>
        <Button 
          onClick={handleClose} 
          color="secondary" 
          disabled={loading}
          variant="outlined"
        >
          Cancelar
        </Button>
        <div className={classes.wrapper}>
            <Button
              onClick={handleSaveNote}
              color="primary"
              variant="contained"
              disabled={loading || note.trim() === ''}
            >
              Guardar Nota
            </Button>
            {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default NoteModal;